import { useSelector } from 'react-redux';

import { CodeReviewConversation } from 'src/components/conversation-provider/types';
import { getAllConversationsForFile } from 'src/selectors/conversation-selectors';
import { Diff } from 'src/types/pull-request';
import { BucketState } from 'src/types/state';

interface CommentDetails {
  hasCurrentComments: boolean;
  outdatedCommentCount: number;
}

const getCommentDetails = (
  conversations: CodeReviewConversation[]
): CommentDetails => {
  let hasCurrentComments = false;
  let outdatedCommentCount = 0;
  conversations.forEach(conversation => {
    if (conversation.meta.outdated) {
      outdatedCommentCount += conversation.comments.length;
    } else {
      hasCurrentComments = true;
    }
  });
  return { hasCurrentComments, outdatedCommentCount };
};

export const useCommentDetailsForFile = (file: Diff): CommentDetails => {
  const conversations = useSelector((state: BucketState) =>
    getAllConversationsForFile(state, file)
  );

  return getCommentDetails(conversations);
};
